export default __webpack_public_path__ + "static/cruiselines-vv-activities-5-6c194cdb57ff7d4d4eb74d8631d5f3ab.jpg";